<template>
  <div class="row mt-4">
    <div class="col-lg-12">
      <div class=" d-flex justify-content-between align-items-center">
        <div class="bcs-title">{{ $t('RECENT_BEST') }}</div>
        <router-link :to="{ path: '/ranking-best-all', query: { tournament_id: tournamentId , type: type}}">
          {{ $t('SEE_ALL') }}
        </router-link>
      </div>
      <hr>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12" v-for="ranking in rankingList" :key="ranking.user_id">
      <div class="bcs-content d-flex justify-content-between align-items-center" @click="setRankingUser(ranking)">
        <div class="d-flex align-items-center">
          <img :src="ranking.image_url"
               class="rounded-circle"
               width="50" height="50"
               :alt="ranking.name"/>
          <div class="rank rounded-circle ">
            <p>{{ convertNumberToLangWise(ranking.position) }}</p>
          </div>
          <div class="d-flex-column m-lg-3">
            <p class="p-name">{{ ranking.name }}</p>
            <p class="p-level">{{ $t('LEVEL') }} {{ convertNumberToLangWise(ranking.level) }}</p>
          </div>

        </div>
        <div style="color: #3EAAFF; font-weight: 700;"> {{ convertNumberToLangWise(ranking.points) }}</div>
      </div>
    </div>

    <RankingModal :modal-show="showModal"
                  :ranking-user="rankingUser"
                  v-if="showModal"/>

  </div>
</template>

<script>
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import RankingModal from "@/views/components/RankingModal";

export default {
  name: "RankingList",
  props: ['rankingList', 'tournamentId', 'type'],
  components: {
    RankingModal
  },
  data() {
    return {
      showModal: false,
      rankingUser: [],
    }
  },
  created() {
    this.emitter.on('modal-close-event', (evt) => {
      this.showModal = evt.eventContent;
      this.rankingUser = [];
    });
    this.emitter.on('update-user-event', (evt) => {
      this.updateUserData(evt.userId);
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    setRankingUser(user_data) {
      this.rankingUser = user_data;
      this.showModal = true;
    },
    updateUserData(id) {
      this.rankingList.forEach((element, index) => {
        if (element.user_id === id) {
          // eslint-disable-next-line vue/no-mutating-props
          this.rankingList[index].friendship_status = 'requested';
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
